import globals from '../../config/globals.json'

const Footer = () => {
    return (
        // <footer className="footer bg-dark text-white fixed-bottom">
        //     <img src={globals.IMAGE_PATH.GENERIC + "/logo-white.png"} alt="dixxip_logo" />
        // </footer>
        ""
    );
}
export default Footer;